// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/cssWithMappingToString.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".basic-list-loader[data-v-14ef030a]{background:var(--white);padding:10px}\n", "",{"version":3,"sources":["webpack://./src/components/Shared/BasicListLoader.vue"],"names":[],"mappings":"AACA,oCACC,uBAAwB,CACxB,YAAa","sourcesContent":["\n.basic-list-loader {\n\tbackground: var(--white);\n\tpadding: 10px;\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
